import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoalibaugcab() {



  const cardData = {
"keyword": "Pune to Alibag Cab",

"headingDescription":
  "Shivai Travels offers reliable and comfortable Pune to Alibag Cab for travelers seeking safe, affordable, and convenient coastal transportation. Whether you are planning a beach holiday, family trip, weekend getaway, or relaxing seaside vacation, our taxi service ensures a smooth and stress-free journey. With experienced drivers, clean air-conditioned vehicles, and transparent pricing with no hidden charges, we provide a dependable travel experience from Pune to Alibag. Our fleet includes sedans, SUVs, Innova cars, and premium vehicles suitable for solo travelers, families, and groups. With flexible one-way and round-trip options, doorstep pickup, easy cab booking, and 24/7 customer support, Shivai Travels ensures a comfortable journey to one of Maharashtra’s most popular coastal destinations.",

"topPlaces": [
  {
    "title": "Alibaug Beach",
    "description":
      "Alibaug Beach is the main attraction of the region known for its calm shoreline, scenic sunset views, and peaceful coastal atmosphere. Travelers booking Pune to Alibag Cab often start their trip here."
  },
  {
    "title": "Alibaug Fort (Kolaba Fort)",
    "description":
      "Alibaug Fort, also known as Kolaba Fort, is a historic sea fort located just off the coast and accessible during low tide, offering a unique heritage experience."
  },
  {
    "title": "Nagaon Beach",
    "description":
      "Nagaon Beach is famous for its clean sand, water sports activities, and serene environment, making it a favorite among families and adventure lovers."
  },
  {
    "title": "Kihim Beach",
    "description":
      "Kihim Beach is known for its white sand, coconut trees, and peaceful surroundings, ideal for relaxation and nature walks."
  },
  {
    "title": "Varsoli Beach",
    "description":
      "Varsoli Beach is a quiet and less crowded beach near Alibaug offering a calm atmosphere for visitors seeking relaxation."
  },
  {
    "title": "Murud-Janjira Fort",
    "description":
      "Murud-Janjira Fort is a powerful sea fort built on an island, famous for its strong architecture and historical significance near Alibaug."
  },
  {
    "title": "Revdanda Beach & Fort",
    "description":
      "Revdanda Beach and Fort offer a mix of history and coastal beauty, making it a popular stop during Alibaug trips."
  },
  {
    "title": "Kashid Beach",
    "description":
      "Kashid Beach is known for its clean white sand, clear water, and scenic surroundings, making it one of the most beautiful beaches near Alibaug."
  },
  {
    "title": "Mandwa Jetty",
    "description":
      "Mandwa Jetty is a key arrival point for ferry travelers from Mumbai and a popular scenic coastal spot near Alibaug."
  },
  {
    "title": "Alibaug Coastal Route",
    "description":
      "The route from Pune to Alibaug passes through scenic highways, villages, and coastal roads, offering a refreshing and enjoyable travel experience."
  }
],



services: [
  {
    name: "Pune to Alibag Cab",
    description: "Pune to Alibag cab service provides reliable transportation between Pune and Alibag with comfortable vehicles and experienced drivers. Vehicles are suitable for highway and coastal travel ensuring smooth and safe journeys for families, tourists, and holiday travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Alibag. Vehicles include sedans, SUVs, Innova Crysta, Ertiga, and premium taxis suitable for different travel requirements. Flexible booking options allow convenient one-way and round-trip cab reservations."
  },
  {
    name: "Pune to Alibag Taxi",
    description: "Pune to Alibag taxi service offers dependable transportation for passengers traveling between Pune and Alibag with professional chauffeurs and comfortable vehicles. Vehicles provide spacious seating and smooth highway travel suitable for beach holidays, sightseeing, and family journeys. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Alibag. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Cab from Pune to Alibag",
    description: "Cab from Pune to Alibag service provides comfortable intercity transportation for passengers traveling for beach vacations, tourism, and family trips. Vehicles ensure reliable highway travel with experienced chauffeurs offering safe and smooth journeys. Pickup services are available from residential areas, offices, hotels, railway stations, and airports across Pune and Alibag. Ideal for one-way and round-trip travel requirements. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Taxi from Pune to Alibag",
    description: "Taxi from Pune to Alibag service offers reliable transportation with comfortable vehicles and professional drivers for travel between Pune and Alibag. Vehicles provide smooth highway and coastal route travel suitable for tourism, sightseeing, and family trips. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Alibag. Flexible booking options allow easy taxi reservations."
  },
  {
    name: "Pune to Alibag Cab Service",
    description: "Pune to Alibag cab service provides dependable transportation solutions for passengers traveling between Pune and Alibag with comfortable vehicles and experienced chauffeurs. Vehicles are suitable for long-distance coastal travel ensuring safe and smooth journeys for individuals, families, and group travelers. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Alibag. Ideal for beach vacations, tourism, and weekend trips. Flexible booking options allow convenient cab reservations."
  },
  {
    name: "Pune to Alibag Taxi Fare",
    description: "Pune to Alibag taxi fare service provides transparent pricing information for passengers planning travel between Pune and Alibag. Travelers can estimate transportation costs based on vehicle type, travel distance, and trip requirements. Comfortable vehicles ensure smooth highway travel with professional drivers offering safe transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Alibag. Flexible booking options allow convenient fare estimation and taxi reservations."
  },
  {
    name: "Pune to Alibag One Way Cab",
    description: "Pune to Alibag one way cab service provides economical transportation for passengers traveling from Pune to Alibag without return travel requirements. Comfortable vehicles ensure smooth highway travel suitable for beach holidays, tourism, and family travel. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune and Alibag including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient one-way cab reservations."
  },
  {
    name: "Pune to Alibag Round Trip Taxi",
    description: "Pune to Alibag round trip taxi service offers convenient return transportation for passengers planning travel between Pune and Alibag. Comfortable vehicles provide smooth highway journeys with experienced drivers ensuring safe and reliable transportation services. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Alibag. Ideal for tourism, sightseeing, and family vacations. Flexible booking options allow convenient round-trip taxi reservations."
  },
  {
    name: "Pune to Alibag Cab Booking",
    description: "Pune to Alibag cab booking service allows passengers to reserve comfortable transportation between Pune and Alibag. Vehicles include sedans, SUVs, luxury cars, Innova Crysta, and premium taxis suitable for different passenger requirements. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Alibag. Flexible booking options allow instant and advance cab reservations."
  },
  {
    name: "Cheap Pune to Alibag Cab",
    description: "Cheap Pune to Alibag cab service provides affordable transportation between Pune and Alibag with comfortable vehicles and economical pricing. Vehicles ensure reliable highway travel suitable for beach holidays, family journeys, and tourism. Professional drivers ensure safe driving and timely pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Alibag. Flexible booking options allow convenient low-cost cab reservations."
  },
  {
    name: "Best Pune to Alibag Taxi",
    description: "Best Pune to Alibag taxi service offers premium transportation with comfortable vehicles and professional chauffeurs for smooth coastal travel. Vehicles provide spacious seating, luggage capacity, and reliable highway performance suitable for beach vacations, tourism, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune and Alibag. Flexible booking options allow convenient taxi reservations."
  },
  {
    name: "Sedan Pune to Alibag Cab",
    description: "Sedan Pune to Alibag cab service offers economical and comfortable transportation for solo travelers, couples, and small families traveling between Pune and Alibag. Sedan vehicles provide smooth highway travel with comfortable seating and luggage space suitable for coastal journeys. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Alibag. Flexible booking options allow convenient sedan cab reservations."
  },
  {
    name: "SUV Pune to Alibag Taxi",
    description: "SUV Pune to Alibag taxi service provides spacious transportation for families and groups traveling between Pune and Alibag. SUV vehicles offer comfortable seating, luggage capacity, and smooth highway performance suitable for beach vacations and family journeys. Professional chauffeurs ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune and Alibag. Flexible booking options allow convenient SUV taxi reservations."
  },
  {
    name: "Innova Pune to Alibag Cab",
    description: "Innova Pune to Alibag cab service provides premium SUV transportation for passengers seeking comfortable and reliable coastal travel. Innova vehicles offer spacious seating, smooth ride quality, and luggage space suitable for beach vacations, sightseeing, and family trips. Professional drivers ensure safe driving and punctual pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune and Alibag. Flexible booking options allow convenient Innova cab reservations."
  },
  {
    name: "Beach Cab Pune Alibag",
    description: "Beach cab Pune Alibag service offers dependable transportation for passengers traveling from Pune to the scenic beaches of Alibag. Comfortable vehicles ensure smooth highway and coastal travel suitable for beach holidays, sightseeing, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune and Alibag. Flexible booking options allow convenient beach cab reservations."
  }
],

tableData: [
  ["Pune to Alibag Cab", "Pune to Alibag Taxi"],
  ["Cab from Pune to Alibag", "Taxi from Pune to Alibag"],
  ["Pune to Alibag Cab Service", "Pune to Alibag Taxi Fare"],
  ["Pune to Alibag One Way Cab", "Pune to Alibag Round Trip Taxi"],
  ["Pune to Alibag Cab Booking", "Cheap Pune to Alibag Cab"],
  ["Best Pune to Alibag Taxi", "Sedan Pune to Alibag Cab"],
  ["SUV Pune to Alibag Taxi", "Innova Pune to Alibag Cab"],
  ["Beach Cab Pune Alibag", "Pune to Alibag Cab Service"]
],



 whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Alibag Cab Service",
        WhyChoosedescription: "Shivai Travels provides reliable Pune to Alibag cab service with professional drivers, comfortable vehicles, and punctual pickup for smooth and safe coastal travel."
      },
      {
        WhyChooseheading: "Affordable Pune to Alibag Taxi Fare",
        WhyChoosedescription: "Shivai Travels offers affordable Pune to Alibag cab pricing with transparent fare details and no hidden charges. Customers receive complete fare information before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Alibag Cab Availability",
        WhyChoosedescription: "Our Pune to Alibag cab service operates 24 hours a day for beach vacations, family trips, weekend getaways, sightseeing tours, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Cabs",
        WhyChoosedescription: "All taxis provided by Shivai Travels are fully air-conditioned, sanitized, and regularly maintained to provide comfortable travel experiences for passengers visiting Alibag."
      },
      {
        WhyChooseheading: "One Way & Round Trip Cab Booking",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way Pune to Alibag taxi service, round-trip bookings, beach sightseeing tours, and customized travel packages."
      },
      {
        WhyChooseheading: "Wide Range of Cab Vehicle Choices",
        WhyChoosedescription: "Customers can choose from sedan taxis, Ertiga, Innova, premium Innova Crysta vehicles, and Tempo Travellers suitable for couples, families, tourists, and group tours."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, hotels, Pune Airport, railway stations, and all major Pune locations including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Coastal Routes",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune to Alibag highway and coastal routes, ensuring safe driving, smooth travel, and timely arrival for every beach journey."
      }
    ]
  };

  const faqData = [
    { question: "What is Pune to Alibag cab service?", answer: "Pune to Alibag cab service provides comfortable taxi transportation between Pune and Alibag for beach holidays, family trips, and weekend travel." },
    { question: "Is Pune to Alibag cab service available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 Pune to Alibag cab service." },
    { question: "Which vehicles are available for Pune to Alibag travel?", answer: "Shivai Travels offers sedan taxis, Ertiga, Innova, Innova Crysta, and Tempo Travellers." },
    { question: "Can I book a one-way cab from Pune to Alibag?", answer: "Yes, customers can book one-way as well as round-trip Pune to Alibag taxi services." },
    { question: "Do you provide Alibag sightseeing taxi packages?", answer: "Yes, Shivai Travels provides Alibag sightseeing and customized coastal travel packages." },
    { question: "Are all Pune to Alibag taxis air-conditioned?", answer: "Yes, all taxis are fully air-conditioned and maintained for comfortable travel." },
    { question: "Can I book Pune to Alibag cab service online?", answer: "Yes, customers can easily book Pune to Alibag cab service online or through phone booking." },
    { question: "Do you provide cabs for family and group travel?", answer: "Yes, Shivai Travels provides comfortable vehicles suitable for family tours and group travel." },
    { question: "Are Pune to Alibag cab fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "Is advance booking available for Pune to Alibag cab service?", answer: "Yes, advance booking is available and recommended during weekends, holidays, and peak tourist seasons." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rohan Patwardhan",
      feedback:
        "Booked Pune to Alibag cab service with Shivai Travels. Comfortable vehicle, smooth coastal journey, and excellent driver support.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Pooja Kulkarni",
      feedback:
        "Excellent Pune to Alibag taxi service. Affordable pricing, clean cab, and wonderful beach travel experience.",
      rating: 5
    }
  ];



















  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Alibag Cab Service",
  "image": "https://shivaitravels.com/assets/images/pune-to-alibag-cab.jpg",
  "description": "Book Pune to Alibag cab service for safe and comfortable coastal travel. Shivai Travels offers affordable one-way and round-trip taxi booking with sedan, SUV, Innova, and luxury cab options available 24x7 for beach trips, ferry points, and weekend getaways.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/pune-to-alibag-cab"
  }
};






  return (
    <div>


<Helmet>
  <title>Pune to Alibag Cab Service | Beach Taxi Booking | +91 9689815477</title>

  <meta
    name="description"
    content="Book Pune to Alibag cab service for one-way and round trip travel. Affordable taxi options including sedan, SUV, Innova, and luxury cabs available 24x7 for beach trips, ferry travel, and weekend getaways."
  />

  <meta
    name="keywords"
    content="pune to alibag cab, pune to alibag taxi, cab from pune to alibag, taxi from pune to alibag, pune to alibag cab service, pune to alibag taxi fare, pune to alibag one way cab, pune to alibag round trip taxi, pune to alibag cab booking, cheap pune to alibag cab, best pune to alibag taxi, sedan pune to alibag cab, suv pune to alibag taxi, innova pune to alibag cab, beach cab pune alibag"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/54.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoalibaugcab;